<template>
    <div class="bg-dim flex-col" @click="closeTerm">
        <div class="safe-area absolute">
            <div class="popup-wrap">

                <div v-if="terms === 'termsOfPrivateInfo'">
                    <div class="agree-header">
                      <strong>개인정보 수집/이용 안내</strong>
                      <button aria-label="개인정보 수집/이용 안내 닫기" type="button" class="icon-close"></button>
                    </div>
                    <div class="agree-content">
                        <ul v-for="item in termsOfPrivateInfo.group1">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>
                        <strong class="content-strong"></strong>
                        <ul v-for="item in termsOfPrivateInfo.group2">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

<!--                      <strong class="content-custom"><b><u>3.보유기간 및 이용기간: 사용 완료 후 1년(관계 법령에 따른 보존 의무 기간까지</u></b></strong>-->
                      <strong class="content-custom"><u>3.보유기간 및 이용기간: 사용 완료 후 1년(관계 법령에 따른 보존 의무 기간까지</u></strong>
<!--                      <ul v-for="item in termsOfPrivateInfo.group3">-->
<!--                        <li><p class="content-paragraph">{{item.text}}</p></li>-->
<!--                      </ul>-->

                      <strong class="content-strong"></strong>
                      <ul v-for="item in termsOfPrivateInfo.group3">
                        <li><p class="content-paragraph">{{item.text}}</p></li>
                      </ul>

                    </div>
                </div>

                <div v-if="terms === 'termsOfPrivateRefundInfo'">
                  <div class="agree-header">
                    <strong>개인정보 수집/이용 안내</strong>
                    <button aria-label="개인정보 수집/이용 안내 닫기" type="button" class="icon-close"></button>
                  </div>
                  <div class="agree-content">
                    <ul v-for="item in termsOfPrivateRefundInfo.group1">
                      <li><p class="content-paragraph">{{item.text}}</p></li>
                    </ul>
                    <strong class="content-strong"></strong>
                    <ul v-for="item in termsOfPrivateRefundInfo.group2">
                      <li><p class="content-paragraph">{{item.text}}</p></li>
                    </ul>
                    <strong class="content-custom"><u>3. 보유 및 이용기간: 환불 완료 후 1년 (관계 법령에 따른 보존 의무 기간까지)</u></strong>
                    <strong class="content-strong"></strong>
                    <ul v-for="item in termsOfPrivateRefundInfo.group3">
                      <li><p class="content-paragraph">{{item.text}}</p></li>
                    </ul>

                  </div>
                </div>

                <div v-if="terms === 'termsOfCommercial'">
                    <div class="agree-header">
                      <strong>전자상거래법 8조 2항</strong>
                      <button aria-label="전자상거래법 8조 2항 닫기" type="button" class="icon-close"></button>
                    </div>
                    <div class="agree-content">
                      <strong class="content-strong">1.수집목적</strong>
                      <ul v-for="item in termsOfCommercial.group1">
                        <li><p class="content-paragraph">{{item.text}}</p></li>
                      </ul>
                    </div>
                </div>

                <div v-if="terms === 'termsOfUse'">
                    <div class="agree-header">
                        <strong>서비스 이용 동의</strong>
                        <button aria-label="서비스 이용 동의 닫기" type="button" class="icon-close"></button>
                    </div>
                    <div class="agree-content">
    <!--                    <strong class="content-strong">제 1 장 총칙</strong>-->
    <!--                    <strong class="content-strong">제 1 조 (목적)</strong>-->
    <!--                    <p class="content-paragraph">본 약관은 ㈜이마트(이하 ‘회사’ 라 합니다)가 발행한 이마티콘을 이용과 관련하여 당사자간의 권리, 의무 및 이용절차 등 필요한 제반사항을 규정하는 것을 목적으로 합니다.</p>-->
    <!--                    <strong class="content-strong pt-20">제 2 조 (용어의 정의)</strong>-->
    <!--                    <span class="content-span">본 약관에서 사용하는 용어는 다음과 같이 정의합니다.</span>-->
    <!--                    <ul>-->
    <!--                        <li><p class="content-paragraph">1. ‘이마티콘’이란 회사가 발행하고, 구매 또는 충전하여 사용하는 바코드 형태의 무기명 모바일 금액권으로 매장에서 상품 구매 시 사용할 수 있는 결제수단을 말합니다.</p></li>-->
    <!--                        <li><p class="content-paragraph">2. ‘고객’ 이란 이마티콘을 구매, 충전하거나 기타 정당한 방법으로 소지한 자를 말합니다.</p></li>-->
    <!--                        <li><p class="content-paragraph">3. ‘회원’이란 고객 중 회사가 운영하는 모바일 어플리케이션 이마트앱(이하 ‘이마트앱’) 등을 통해 본 약관과 개인정보의 수집, 제공 및 활용에 관한 동의서에 동의한 자를 말합니다.</p></li>-->
    <!--                        <li><p class="content-paragraph">4. ‘고객 등’이란 고객과 회원을 통칭합니다.</p></li>-->
    <!--                        <li><p class="content-paragraph">5. ‘매장’이란 회사가 직영으로 운영하는 전국 이마트, 트레이더스, 전문점(일렉트로마트, 몰리스, 노브랜드 등) 등 오프라인 매장을 말하며, 이마트, 트레이더스의 문화센터 및 회사(전자금융거래법 시행령 제3조에 따른 특수관계인 포함)외의 제3자가 운영하는 매장(노브랜드 가맹점, 이마트 에브리데이, 이마트24, 이마트 안양점, 이마트 부천점, 이마트 및 트레이더스에 입점되어 있는 푸드코트, 약국, 미용실 등의 임대 매장)은 제외됩니다.</p></li>-->
    <!--                        <li></li>-->
    <!--                    </ul>-->
                        <strong class="content-strong">제 1 장 총칙</strong>
                        <strong class="content-strong">제 1 조 (목적)</strong>
                        <ul v-for="item in termsOfUse.group1">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 2 조 (용어의 정의)</strong>
                        <strong class="content-span">본 약관에서 사용하는 용어는 다음과 같이 정의합니다. </strong>
                        <ul v-for="item in termsOfUse.group2">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 3 조 (약관의 효력 및 변경 등)</strong>
                        <ul v-for="item in termsOfUse.group3">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 4 조 (약관의 해석 등)</strong>
                        <strong class="content-strong">본 약관에서 사용하는 용어는 다음과 같이 정의합니다. </strong>
                        <ul v-for="item in termsOfUse.group4">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong">제 2 장 서비스</strong>
                        <strong class="content-strong pt-20">제 5 조 (이마티콘의 발행)</strong>
                        <ul v-for="item in termsOfUse.group5">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>


                        <strong class="content-strong pt-20">제 6 조 (이마티콘의 이용)</strong>
                        <ul v-for="item in termsOfUse.group6">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>


                        <strong class="content-strong pt-20">제 7 조 (서비스 이용 제한)</strong>
                        <ul v-for="item in termsOfUse.group7">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 8조 (구매 및 충전)</strong>
                        <ul v-for="item in termsOfUse.group8">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 9조 (자동 재충전)</strong>
                        <ul v-for="item in termsOfUse.group9">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 10 조 (결제 확인 통지 • 안내 • 충전신청 변경 및 취소)</strong>
                        <ul v-for="item in termsOfUse.group10">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 11 조 (청약철회 등)</strong>
                        <ul v-for="item in termsOfUse.group11">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 12조 (환급)</strong>
                        <ul v-for="item in termsOfUse.group12">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong pt-20">제 13 조 (고객 등의 의무)</strong>
                        <ul v-for="item in termsOfUse.group13">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong">제 3 장 거래내역 정보</strong>
                        <strong class="content-strong pt-20">제 14 조 (거래내역의 수집)</strong>
                        <ul v-for="item in termsOfUse.group14">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>


                        <strong class="content-strong pt-20">제 15조 (거래내역의 제공)</strong>
                        <ul v-for="item in termsOfUse.group15">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>


                        <strong class="content-strong pt-20">제 16 조 (거래내역의 정정)</strong>
                        <ul v-for="item in termsOfUse.group16">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong">제 4 장 개인정보 보호</strong>
                        <strong class="content-strong pt-20">제 17 조 (개인 정보 보호)</strong>
                        <ul v-for="item in termsOfUse.group17">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                        <strong class="content-strong">제 5 장 기타</strong>
                        <strong class="content-strong pt-20">제 18 조 (책임 소재)</strong>
                        <ul v-for="item in termsOfUse.group18">
                          <li><p class="content-paragraph">{{item.text}}</p></li>
                        </ul>

                      <strong class="content-strong pt-20">제 19 조 (지급 보증 등)</strong>
                      <ul v-for="item in termsOfUse.group19">
                        <li><p class="content-paragraph">{{item.text}}</p></li>
                      </ul>

                      <strong class="content-strong pt-20">제 20 조 (분쟁 해결)</strong>
                      <ul v-for="item in termsOfUse.group20">
                        <li><p class="content-paragraph">{{item.text}}</p></li>
                      </ul>

                      <strong class="content-strong pt-20">제 21 조 (관할 법원)</strong>
                      <ul v-for="item in termsOfUse.group21">
                        <li><p class="content-paragraph">{{item.text}}</p></li>
                      </ul>
                    </div>
                </div>
            </div>
<!--            <bottom-button :buttonArray="buttonArray"></bottom-button>-->
          <div class="button-wrap">
            <button class="button-bg-yellow" @click="closeTerm">확인</button>
          </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'AgreePopup',
    components: {BottomButton},
    props:['terms'],
    data() {
        return  {
            buttonArray : [
                // {
                //     className : "button-bg-gray",
                //     text : "아니요",
                // },
                {
                    className : "button-bg-yellow",
                    text : "확인",
                },
            ],
          termsOfUse:{
            "group1":[
              {"text": "본 약관은 ㈜이마트(이하 '회사'라 합니다)가 발행한 이마티콘을 이용과 관련하여 당사자간의 권리, 의무 및 이용절차 등 필요한 제반사항을 규정하는 것을 목적으로 합니다."}
            ],
            "group2":[
              {"text": "1.	'이마티콘'이란 회사가 발행하고, 구매 또는 충전하여 사용하는 바코드 형태의 무기명 모바일 금액권으로 매장에서 상품 구매 시 사용할 수 있는 결제수단을 말합니다. "},
              {"text": "2.	'고객'이란 이마티콘을 구매, 충전하거나 기타 정당한 방법으로 소지한 자를 말합니다."},
              {"text": "3.	‘회원’이란 고객 중 회사가 운영하는 모바일 어플리케이션 이마트앱(이하 ‘이마트앱’) 등을 통해 본 약관과 개인정보의 수집, 제공 및 활용에 관한 동의서에 동의한 자를 말합니다."},
              {"text": "4.	‘고객 등’이란 고객과 회원을 통칭합니다."},
              {"text": "5.	'매장'이란 회사가 직영으로 운영하는 전국 이마트, 트레이더스, 에브리데이 및 전문점(일렉트로마트, 몰리스, 노브랜드 등) 등 오프라인 매장을 말하며, 이마트, 트레이더스의 문화센터 및  회사(전자금융거래법 시행령 제3조에 따른 특수관계인 포함)외의 제3자가 운영하는 매장(노브랜드 가맹점, 이마트24, 이마트 안양점, 이마트 부천점, 이마트 및 트레이더스에 입점되어 있는 푸드코트, 약국, 미용실 등의 임대 매장)은 제외됩니다. "},
              {"text": "6.	 ‘상품’이란 회사가 판매하는 재화 또는 용역을 말합니다. "},
              {"text": "7.	 ‘서비스’란 고객에게 제공하는 이마티콘 구매, 결제, 충전 등의 서비스로 상세한 내용은 이마트앱에 게시합니다. "},
              {"text": "8.	'잔액 조회'란 이마티콘의 잔액에 대해 문의하는 행위를 말합니다."},
              {"text": "9.	'충전'이란 소지한 이마티콘에 이마트앱을 통하여 금액을 충전하는 행위를 말합니다."},
              {"text":"10.	'환불'이란 이마티콘에 기록된 잔액을 고객과 회사간에 약정된 방법과 절차에 따라 고객에게 돌려주는 것을 말합니다."},
            ],
            "group3":[
              {"text":"1.	본 약관은 그 내용을 회사가 홈페이지 또는 이마트앱에 게시하고, 고객이 이마티콘을 구매 또는 충전 후 정당한 방법으로 소지하여 사용함으로써 그 효력이 발생합니다."},
              {"text":"2.	회사는 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 홈페이지 또는 이마트앱에 그 적용일의 7일 전부터 공시하는 방법으로 회원에게 고지합니다. 다만, 회원에게 불리한 내용으로 약관을 개정하는 경우에는 적용일로부터 30일 전까지 홈페이지 또는 이마트앱에 공시하고 회원이 입력한 가장 최근의 e-mail 또는 회원에게 문자메세지를 전송하는 방법으로 회원에게 고지합니다. 다만, 법령의 개정으로 인하여 긴급하게 약관을 변경한 때에는 변경된 약관을 1개월 이상 게시하고 회원에게 사후 통지합니다."},
              {"text":"3.	본 조의 규정에 의하여 개정된 약관은 원칙적으로 그 변경되는 약관의 효력 발생일로부터 장래를 향하여 유효합니다."},
              {"text":"4.	고객이 변경된 약관 사항에 동의하지 않을 경우, 약관의 효력 발생 전일까지 서비스 이용을 중단하거나 회원탈퇴 및 회원 계정에 등록된 이마티콘을 취소 또는 환불하는 방법으로 이용 계약을 해지할 수 있으며, 약관의 개정과 관련하여 효력 발생일 전일까지 이의를 제기하지 않는 경우에는 개정된 약관에 동의한 것으로 간주합니다."},
            ],
            "group4":[
              {"text":"본 약관에 명시되지 않은 사항 또는 본 약관 해석상 다툼이 있는 경우에는 고객과 회사의 합의에 의하여 결정합니다. 다만, 합의가 이루어지지 않은 경우에는 관계법령 및 거래관행에 따릅니다."},
            ],
            "group5":[
              {"text":"이마티콘은 회사가 발행합니다."},
            ],
            "group6":[
              {"text":"1.	고객은 매장을 직접 방문하여 매장의 계산대에 이마티콘을 제시하는 방법으로 이마티콘의 잔액 범위 내에서 현금과 동일하게 매장의 상품을 구매할 수 있습니다. 여기에서 ‘제시한다’는 것은 이마티콘 바코드를 계산대에 제시하거나 셀프 계산대 단말기로 인식하는 행위 등으로 고객이 발행처로부터 적법하게 인정된 이마티콘의 소유주임을 증명하는 행위를 말합니다."},
              {"text":"2.	고객이 서비스를 이용하고자 이마티콘을 제시하는 경우 회사는 고객에게 본인 확인을 위한 신분증 제시를 요청할 수 있습니다. 이 경우 고객은 회사의 요청을 준수하여야 정상적인 서비스를 제공받을 수 있습니다."},
              {"text":"3.	이마티콘은 제2조 제4호에서 정의된 매장에서 사용 가능합니다. 단, 이마티콘의 발행 목적, 매장의 임대차 계약상 임대인이 요구한 조건, 또는 기술적 사유(시스템 점검, 단말기 고장, 통신회선 불량 등)로 일부 매장에서는 이용이 제한될 수 있으며, 이 경우 회사는 이마트앱 또는 홈페이지 등을 이용하여 고객에게 고지합니다. "},
              {"text":"4.	이마티콘의 잔액에 대한 유효기간은 따로 존재하지 않으나 이벤트, 할인 적용, 사은품 등으로 발행된 이마티콘의 경우에는 별도의 유효기간이 적용될 수 있습니다. "},
              {"text":"5.	도서 공연비 등 추가 소득공제 품목의 경우 다른 일반적인 상품 결제와는 별도의 결제 진행이 필요할 수 있습니다. "},
              {"text":"6.	고객은 문자(MMS)로 수신받은 선물용 또는 마케팅 용도의 이마티콘을 이마트앱에 등록하기 전 제3자에게 문자(MMS)로 전달하는 방식으로 양도할 수 있습니다. 제3자는 이를 이마트앱에 등록한 후 사용할 수 있으며 이마트앱에 이마티콘을 등록한 이후에는 재양도가 불가합니다"},
              {"text":"7.	회원이 동일한 이마티콘 바코드를 여러 번 충전한 경우, 가장 먼저 구매 또는 충전한 순서대로 결제금액이 차감됩니다."},
              {"text":"8.	하나의 이마티콘 바코드에 등록된 잔액을 다른 이마티콘 바코드로 이전하는 것은 불가합니다."},
            ],
            "group7":[
              {"text":"1.	회사는 다음 각호 중 어느 하나에 해당하는 경우 서비스 이용 신청을 승인 거절하거나 승인 취소하는 등 서비스 이용을 제한할 수 있습니다."},
              {"text":"가.	서비스용 설비의 장애 및 보수, 정전, 이용량의 폭주 등 회사가 기술상 서비스를 제공할 수 없는 경우"},
              {"text":"나.	고객 등이 회사의 서비스 정책 또는 본 약관을 위반하여 서비스를 이용하고자 하는 경우"},
              {"text":"다.	고객 등이 회사가 의도하지 않은 방법으로 서비스를 이용하거나 회사에 손실을 끼치는 경우"},
              {"text":"라.	고객 등이 회사가 제공하는 방식이 아닌 불법 또는 부정한 방법으로 이마티콘을 구매하거나 사용하고자 하는 경우"},
              {"text":"마.	기타 회사가 정한 요건을 충족하지 않은 경우"},
              {"text":"2.	회사는 본 조에 따라 서비스 이용을 제한할 경우 해당 내용을 회원이 입력한 가장 최근의 e-mail 또는 문자메세지를 전송하는 방법으로 통지합니다. 단, 불특정다수 고객에 대한 통지의 경우 1주일 이상 홈페이지 또는 이마트앱에 게시함으로써 개별 통지를 갈음할 수 있습니다. "},
              {"text":"3.	다만, 회사의 귀책사유 없는 디스크 장애, 시스템 다운 등 회사가 통제할 수 없는 사유가 발생하여 서비스 이용 제한 사실을 미리 통지할 수 없는 경우, 그러한 사유가 해소된 후 즉시 본 조 제2항에 따라 통지할 수 있습니다."},
            ],
            "group8":[
              {"text":"1.	이마티콘은 이마트앱(선물용으로 수신받은 이마티콘은 이마트앱에 등록하여야 함)에서 회사가 현금과 동일하게 인정하는 금전적 가치(신용카드 등)로 구매 또는 충전이 가능합니다. "},
              {"text":"2. 이마티콘은  최대 50만원을 총 금액 한도로 하여 1만원 단위로충전할 수 있습니다. 최소 충전 금액 및 최대 충전 한도는 회사의 마케팅 정책에 따라 변경될 수 있으며, 변경 시 회사는 이를 회사의 홈페이지 또는 이마트앱에 공지합니다."},
              {"text":"3. 이마티콘의 구매 및 충전 금액에 대하여는 이자가 발생하지 않습니다."},
              {"text":"4. 다음 각호에 해당되는 경우 회사는 고객의 충전을 제한할 수 있습니다."},
              {"text":"가.	최대 충전한도를 초과한 경우 "},
              {"text":"나.	회사가 예정한 이마티콘 이용방법에 의하지 아니하고 비정상적인 방법으로 서비스를 이용하는 것으로 판단되는 경우 "},
              {"text":"다.	타인의 명의, 계좌정보 등을 도용하여 회사가 제공하는 이마티콘 충전 서비스를 이용하는 것으로 판단되는 경우"},
              {"text":"라.	회사가 마케팅/사은품용으로 지급한 이마티콘의 경우 "},
              {"text":"마.	기타 충전이 불가능한 기술적, 제도적 사유가 발생한 경우"}
            ],
            "group9":[
              {"text":"이마트앱에 등록된 이마티콘의 경우, 아래와 같은 방법으로 자동 재충전을 설정할 수 있습니다."},
              {"text":"가.	기준 하한 자동 재충전: 회원이 지정한 카드의 최저 잔액 이하로 잔액이 하락하는 경우, 회원이 사전에 선택한 결제수단으로 지정한 금액이 재충전 됩니다."},
              {"text":"나.	월 정액 자동 재충전: 회원이 지정한 특정 일자에 사전에 선택한 결제수단으로 지정한 금액이 재충전 됩니다."},
            ],
            "group10":[
              {"text":"회사는 회원이 구매 또는 충전을 한 동시에 확인 통지를 발송합니다. 회사의 결제 확인 통지가 회원에게 도달한 시점에 계약이 성립된 것으로 보고, 그 통지에는 다음 각호의 사항이 포함됩니다."},
              {"text":"가.	발행자"},
              {"text":"나.	구매/충전 가격(할인된 경우 할인율 및 할인금액)"},
              {"text":"다.	사용조건"},
              {"text":"라.	사용가능 매장"},
              {"text":"마.	환불 조건 및 방법"},
              {"text":"바.	지급보증 또는 피해보상보험계약 체결에 관한 사항"},
              {"text":"사.	소비자피해발생 시 연락할 관련 전화번호"},
            ],
            "group11":[
              {"text":"1.	회원은 구매(선물용으로 구매한 이마티콘을 포함합니다) 또는 충전한 이마티콘이 사용되지 않은 경우에 한하여 7일 이내에 그 청약의 철회를 할 수 있습니다. 이 때 이마티콘의 사용 여부는 개별 충전/구매 금액을 단위로 하여 판단하며, 고객이 이마티콘을 일부라도 사용한 경우에는 제12조의 환급 규정에 따라 환급해 드립니다."},
              {"text":"2.	회사는 회원이 청약철회를 통지한 경우 즉시 청약철회를 요청한 이마티콘의 이용을 제한합니다. "},
              {"text":"3.	회사는 본 조 제1항의 청약철회를 수신한 날부터 3영업일 이내에 지급받은 대금을 환급하거나 환급에 필요한 조치를 합니다. 이 경우 그 환급을 지연하는 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 시행령이 정하는 지연이자율(연 100분의 15)을 곱하여 산정한 지연이자를 지급합니다."},
              {"text":"4.	회사는 제3항의 대금을 반환함에 있어서 회원이 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다."},
            ],
            "group12":[
              {"text":"회원이 이마티콘에 대하여 환급을 요청하는 때에는 개별 이마티콘 바코드를 기준으로 구매/ 충전 금액을 순차적으로 차감하는 방식으로 사용여부를 판단한 뒤 다음의 명시된 절차에 의거하여 환급을 처리합니다. "},
              {"text":"예) ① 회원이 30,000원의 이마티콘을 구매하고 ② 50,000원의 이마티콘을 충전한 뒤, ③ 이마티콘으로 9,000원의 물품 구매 시 ④ 9,000원의 물품은 30,000원에서 결제된 것으로 판단하며, 50,000원은 사용하지 않은 것으로 판단합니다. "},
              {"text":"1.	구매/충전한 이마티콘을 사용하지 않은 경우(사용 건을 모두 취소하여 금액을 복원 시킨 경우를 포함합니다. 이하 같습니다.) : 결제수단의 취소를 통해 처리되나, 결제대행사의 정책에 따라 결제수단의 취소가 불가능할 경우 회사는 이마트앱에 입력한 회원 본인의 계좌로 환급절차를 진행합니다. "},
              {"text":"2.	구매/충전한 이마티콘의 일부를 사용한 경우 "},
              {"text":"가.	회원은 이마티콘의 개별 구매/충전 금액을 기준으로 60% 이상을 사용한 경우에만 이마트앱을 통해 잔액의 환급을 신청할 수 있습니다. "},
              {"text":"나.	할인 구매/충전한 이마티콘의 경우에는 제1항의 기준을 적용하되, 구매/충전 시에 실제 지급한 금액을 기준으로 잔액을 계산하여 환급해드립니다"},
              {"text":"예) 이마티콘 100,000원의 이마티콘을 90,000원으로 10% 할인 구매 후, 60,000원을 물품 구매 등에 사용한 뒤 환불 신청을 할 경우 잔액 40,000원에서 10%를 제외한 36,000원을 환불해 드립니다."},
              {"text":"3.	선물용 이마티콘의 경우"},
              {"text":"가.	수신자가 문자(MMS)로 선물 받은 이마티콘을 이마트앱에 등록한 경우 : 본 조 제2항에 따라 수신자에게 환급을 진행합니다. "},
              {"text":"나.	수신자가 문자(MMS)로 선물 받은 이마티콘을 이마트앱에 등록하지 않은 경우: "},
              {"text":"(1)	수신자가 선물 받은 이마티콘을 사용한 경우 : 본 조 제2항의 기준에 따라 수신자에게 환급을 진행합니다. 이때 수신자는 이마트 콜 센터를 통해 환급 신청이 가능하며, 회사는 이마티콘 수신인의 인증(수신 받은 핸드폰번호, 이름, 이마티콘 쿠폰번호)절차를 거친 후 본 조 제2항 가호의 기준에 따라 환급을 진행합니다.  "},
              {"text":"(2)	수신자가 선물 받은 이마티콘을 사용하지 않은 경우: 본 조 제1항의 기준에 따라 결제 명의자에게 환급을 진행합니다. "},
              {"text":"4.	회사가 마케팅/사은품용으로 지급한 이마티콘은 환급이 되지 않습니다."},
              {"text":"5.	회원이 본 조 제1항 내지 제3항에 따라 이마트앱을 통해 이마티콘 잔액에 대한 계좌 환급을 신청하면, 회사는 이를 확인 후 회원이 지정한 계좌로 신청일로부터 영업일 기준 7일 이내에 잔액을 환급하는 것을 원칙으로 합니다. 단, 회원 본인의 환급 신청 계좌정보를 오입력 또는 부정 사용 등으로 인해 확인 절차가 필요한 경우, 회사의 책임으로 돌릴 수 없는 사유로 환급이 지연되는 경우 등에는 환급이 지연될 수 있습니다."},
              {"text":"6.	기술적 사유(시스템 점검, 통신회선 불량, 단말기의 안정화 작업 등)로 일부 이마티콘 환급이 제한될 수 있으며, 이 경우 회사는 별도의 환급 절차 및 방법을 이마트앱 을 이용하여 회원에게 고지합니다."},
            ],
            "group13":[
              {"text":"1.	고객 등은 이 약관에서 규정한 사항과 이용안내 또는 공지사항 등을 통하여 회사가 제공하는 사항을 준수하여야 하며, 회사 업무에 방해되는 행위를 하여서는 안 됩니다. "},
              {"text":"2.	고객 등은 이마티콘을 구매하기 전에 반드시 상세 내용과 거래의 조건을 확인한 후 구매를 신청하여야 합니다. 구매하려는 이마티콘의 상세내용과 거래 조건을 확인하지 않고 구매하여 발생하는 손해에 대하여는 고객이 책임을 부담합니다."},
              {"text":"3.	고객 등은 구매한 이마티콘을 이용해 어떠한 영리활동도 할 수 없습니다."},
              {"text":"4.	고객 등은 회사가 서비스를 안전하게 제공할 수 있도록 회사에 협조하여야 하며, 회사가 고객 등의 본 약관 위반행위를 발견하여 고객 등에게 소명을 요청할 경우 고객 등은 회사의 요청에 적극 응하여야 합니다."},
            ],
            "group14":[
              {"text":"1.	회사는 고객 등이 이마티콘 서비스 이용 및 이마티콘을 통한 제품 또는 상품 구매 시 필요한 최소한의 거래내역 정보(카드 번호, 거래 일시, 거래 금액, 단말기 및 매장 정보 등)를 수집합니다."},
              {"text":"2.	이마티콘을 통해 수집된 거래내역 정보는 이용대금 정산의 목적 및 (개인정보의 경우 개인정보보호 관련 법령에 따른 비식별화 조치를 거쳐) 회사의 통계 작성 및 활용의 목적에 사용될 수 있습니다."},
            ],
            "group15":[
              {"text":"1.	회원은 이마트앱을 통해 거래 내역을 확인할 수 있습니다."},
              {"text":"2.	회사는 회원과 거래한 내역 및 그 증빙을 전자 영수증으로 발급하며, 회원은 이에 동의합니다."},
              {"text":"3.	회사는 관련법령에 의거하여 회원과의 거래내역을 거래가 발생한 날로부터 최대 5년 간 보관하며, 해당 기간 동안 회원은 회사가 제공하는 이마트앱을 통하여 최근 1년 간의 거래 내역을 열람 및 확인할 수 있습니다."},
              {"text":"4.	회사는 다음 각호에 해당하는 경우, 거래내역 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다."},
              {"text":"가.	서비스를 위한 설비 보수, 점검, 교체 등의 사유로 일시적인 서비스 장애가 발생한 경우"},
              {"text":"나.	제반 설비의 장애 또는 이용폭주로 정상적인 서비스 이용이 어려운 경우"},
              {"text":"다.	천재지변 등 불가항력적 사유가 발생한 경우"},
              {"text":"5.	고객 등이 사용 내역을 서면으로 확인하고자 하는 경우, 이마티콘을 소지한 본인이 사용내역 증빙(이마트앱의 결제내역, 발송된 MMS문자 등)을 소지하여 전국 이마트 오프라인 매장에서 발행 요청을 할 수 있습니다."},
              {"text":"6.	고객 등은 매장에서 이마티콘을 사용하면서 현금영수증 발급을 요구할 수 있고, 매장은 이에 따라 현금영수증을 발행해야 합니다."},
              {"text":"단, 이벤트 목적으로 제공되는 이마티콘(이벤트 참여 경품, 유니버스 가입 혜택 등)은 현금영수증 발급이 불가합니다."},
            ],
            "group16":[
              {"text":"1.	고객 등은 본인이 이용한 거래와 관련된 오류를 발견하는 경우 소명할 수 있는 자료를 갖추고 회사가 정한 절차를 거쳐, 해당 거래에 대한 정정을 요청할 수 있습니다."},
              {"text":"2.	회사는 본 조 제1항에 의해 고객의 정정 요청을 받은 날로부터 2주 이내에 해당 거래내역을 검토하여 그 결과를 통보합니다."},
            ],
            "group17":[
              {"text":"1.	회사는 고객 등의 정보 수집 시 정상적인 서비스를 위한 최소한의 정보를 수집하며, 고객 등의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 해당 고객의 동의를 받습니다."},
              {"text":"2.	회사는 양질의 서비스를 제공하기 위해 여러 비즈니스 파트너와 제휴를 맺거나 국가 기관의 요구 등을 위해 개인정보를 위탁관리 하거나 개인정보를 제공할 수 있습니다. 개인정보 위탁의 경우에는 홈페이지를 통해 관련 사항을 공개하고, 개인정보 제공의 경우에는 제공과 관련된 사항을 고객에게 알리고 동의를 받습니다. 단, 고객의 소득공제 목적으로 국세청에 개인정보 및 이마티콘 사용내역을 제공하는 경우 등과 같이 고객의 요청에 의하는 경우는 예외로 합니다."},
              {"text":"3.	회사는 고객 등이 제공한 개인정보는 고객 등의 동의 없이 제3자에게 누설하거나 제공하지 않습니다. 다만, 다음 각호에 해당하는 경우에는 예외로 합니다."},
              {"text":"가.	통계 작성, 과학적 연구 또는 공익적 기록보존 등을 위해 특정 개인을 식별할 수 없는 형태로 제공하는 경우"},
              {"text":"나.	관계 법령에 의하여 수사상의 목적으로 관계 기관으로부터 요구 받은 경우"},
              {"text":"다.	기타 관계 법령에 의한 경우"},
              {"text":"4.	고객 등은 자신의 개인정보처리와 관련하여 개인정보의 처리에 관한 정보를 제공받을 권리, 개인정보에 대하여 열람을 요구할 권리, 개인정보의 처리정지, 정정, 삭제 및 파기를 요구할 권리를 갖습니다."},
              {"text":"5.	회사 또는 회사로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기하여야 합니다."},
            ],
            "group18":[
              {"text":"1.	회사는 고객 등이 이마티콘 서비스 이용 중 발생한 손해에 대하여 배상할 책임을 집니다. 단, 본 약관에 별도 명시된 경우 및 다음 각호의 어느 하나에 해당하는 경우는 제외합니다."},
              {"text":"가.	고객 등이 이마티콘을 회사가 지정하지 아니한 방법으로 불법 거래 또는 부정 사용한 경우"},
              {"text":"나.	제3자가 권한 없이 고객 등의 이마티콘을 이용할 수 있음을 알았거나 쉽게 알 수 있었음에도 불구하고 고객 등이 자신의 이마티콘 정보(이마티콘 PIN 번호)를 누설 또는 노출하거나 방치한 경우"},
              {"text":"다.	고객 등이 본인의 정보를 잘못 입력(문자 수신 번호, 구매자 정보, 환불 계좌번호 오입력 등)하여 손해가 발생한 경우 "},
              {"text":"2.	고객 등이 본 조 제1항에서 규정한 행위를 하여 회사에 손해가 발생하는 경우, 그 고객 등은 회사의 손해에 대하여 배상할 책임을 집니다."},
              {"text":"3.	서비스를 이용하면서 불법행위나 본 약관을 위반하는 행위를 한 고객 등으로 말미암아 회사가 해당 고객 등 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는다면 해당 고객 등은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 고객 등은 그로 인하여 회사에 발생한 손해를 배상해야 합니다."},
              {"text":"4.	회사는 고객 등이 불법 또는 부정한 방법으로 서비스를 이용하거나 과실에 해당하는 행위를 하여 고객 등간 또는 고객 등 및 제3자 상호간에 분쟁이 발생하였을 때 회사의 책임을 주장하는 자가 회사의 귀책사유를 객관적으로 입증하지 않는 한, 회사는 이에 개입할 의무가 없으며 분쟁으로 발생하는 손해를 배상할 책임이 없습니다."},
            ],
            "group19":[
              {"text":"이마티콘은 구매 및 충전금액에 대하여 전자상거래(결제수단) 보증보험증권에 가입되어 있습니다."},
            ],
            "group20":[
              {"text":"1.	회사는 고객 등이 제기하는 정당한 의견이나 불만을 반영하기 위하여 고객의견수렴 제도를 운영하며, 고객 등은 홈페이지의 해당 서비스 페이지를 통해 의견을 제시할 수 있습니다."},
              {"text":"o	홈페이지 주소: www.Emart.com"},
              {"text":"o	이마트 콜센터: 02-380-5030"},
              {"text":"2.	회사는 고객 등에게 손해가 발생하거나 회사와 고객 등간 분쟁이 발생하는 경우 손해 배상 등 분쟁처리를 위해 고객상담센터를 설치 운영합니다."},
              {"text":"3.	회사는 고객 등이 불만사항 및 의견을 제출하는 경우 15일 이내에 이를 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 고객 등에게 그 사유와 처리일정을 즉시 통보합니다."},
              {"text":"4.	회사와 고객 등간에 발생한 분쟁이 원만히 해결되지 않는 경우, 관련 법령에 따라 소비자기본법에 따른 한국소비자원의 소비자분쟁조정위원회를 통해 조정신청이 가능합니다."},

            ],
            "group21":[
              {"text":"이마티콘 및 본 약관과 관련한 제반 분쟁 및 소송은 회사의 본점 소재지를 관할하는 법원 또는 민사소송법상의 관할 법원을 제1심 관할 법원으로 합니다."},
            ],
          },
          termsOfPrivateInfo:{
              "group1" : [
                {"text": "1. 수집/이용 항목: 수신자 이름, 휴대전화번호 서비스 이용과정에서 발생한 상품 및 서비스 구매내역 (결제시: 비밀번호)"},
              ],
            "group2" : [
              {"text": "2. 수집/이용 목적"},
              {"text": " 1) 서비스 제공 및 본인 확인 절차"},
              {"text": " 2) 서비스 제공을 위한 계약 이행 및 정산"},
              {"text": " - 각종 편의 서비스 및 혜택 제공, 상품 및 서비스에 대한 주문 및 접수 확인, 대금 결제 확인, 고객센터 운영, 공지사항 전달 및 본인의사 확인, 민원처리, 사고조사를 위한 원활한 의사소통 경로 확보"},
            ],
            "group3" : [
              {"text": "※ 개인정보를 기재하지 않으실 수 있습니다. 단, 기재하지 않으시는 경우에는 상기 목적의 서비스 이용이 불가합니다."},
            ]
          },

          termsOfPrivateRefundInfo:{
            "group1" : [
              {"text": "1. 수집/이용 항목: 예금주 이름, 은행명, 계좌번호"},
            ],
            "group2" : [
              {"text": "2. 수집/이용 목적"},
              {"text": " 1) 서비스 제공 및 본인 확인 절차"},
              {"text": " 2) 서비스 제공을 위한 계약 이행 및 정산"},
              {"text": " - 각종 편의서비스 및 혜택 제공, 상품 및 서비스에 대한 주문 및 접수 확인, 대금 결제 확인, 고객센터 운영, 공지사항 전달 및 본인의사 확인, 민원처리, 사고조사를 위한 원활한 의사소통 경로 확보"},
            ],
            "group3" : [
              {"text": "※ 개인정보를 기재하지 않으실 수 있습니다. 단, 기재하지 않으시는 경우에는 상기 목적의 서비스 이용이 불가합니다."},
            ]
          },

          termsOfCommercial: {
              "group1":[
                {"text":"사업자와 전자결제업자등은 전자적 대금지급이 이루어지는 경우 소비자의 청약의사가 진정한 의사 표시에 의한 것인지를 확인하기 위하여 다음 각 호의 사항에 대하여 명확히 고지하고, 고지한 사항에 대한 소비자의 확인절차를 대통령령으로 정하는 바에 따라 마련하여야 한다."},
                {"text": "1. 재화등의 내용 및 종류"},
                {"text": "2. 재화등의 가격"},
                {"text": "3. 용역의 제공기간"}
              ],
          }

        }
    },
    
    methods : {
      closeTerm() { //서비스 이용약관 닫기
        this.$emit('close', false);
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/products/agreePopup.scss';
</style>